import { createRouter, createWebHistory } from 'vue-router'
import { useApiStore } from '@/stores/api.js'

const $router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/digital-signage/:id',
      component: () => import('./views/DigitalSignage.vue')
    },
    {
      path: '/',
      component: () => import('./views/Workspace.vue'),
      meta: {
        auth: true,
      }
    },
    {
      path: '/share/:id',
      component: () => import('./views/Share.vue')
    },
    {
      path: '/settings',
      redirect: '/settings/account',
      meta: {
        auth: true,
      }
    },
    {
      path: '/settings/account',
      component: () => import('./views/settings/Account.vue'),
      meta: {
        auth: true,
      }
    },
    {
      path: '/settings/users',
      component: () => import('./views/settings/Users.vue'),
      meta: {
        auth: true,
      }
    },
    {
      path: '/settings/media-attribute-schema',
      component: () => import('./views/settings/MediaAttributeSchema.vue'),
      meta: {
        auth: true,
      }
    },
    {
      path: '/settings/media-attribute-value-lists',
      component: () => import('./views/settings/MediaAttributeValueList.vue'),
      meta: {
        auth: true,
      }
    },
    {
      path: '/settings/reported-media',
      component: () => import('./views/settings/ReportedMedia.vue'),
      meta: {
        auth: true,
      }
    },
    {
      path: '/settings/output-formats',
      component: () => import('./views/settings/OutputFormats.vue'),
      meta: {
        auth: true,
      }
    },
    {
      path: '/settings/api-keys',
      component: () => import('./views/settings/ApiKeys.vue'),
      meta: {
        auth: true,
      }
    },
    {
      path: '/auth/login',
      component: () => import('./views/auth/Login.vue')
    },
    {
      path: '/auth/logout',
      component: () => import('./views/auth/Logout.vue')
    }
  ]
})

$router.beforeEach((to, from, next) => {
  if (to.meta.auth && !useApiStore().isAuthenticated()) {
    let queryParams = []
    if (to.query.sf) {
      queryParams.push(`sf=${to.query.sf}`)
    }
    if (to.query.sm) {
      queryParams.push(`sm=${to.query.sm}`)
    }
    if (queryParams) {
      return next(`/auth/login?${queryParams.join('&')}`)
    }
    return next(`/auth/login`)
  }
  return next()
})

export default $router